export const ThemeType = {
  DARK: 'dark',
  RED: 'red',
  LIGHT: 'light',
  DEFAULT: 'default',
};
